import React from 'react';
import { useSelector } from 'react-redux';
import LineChart from './echarts/LineChart/index-beta';
import BarChart from './echarts/BarChart';
import { EVOLUTIVE_CARD } from 'src/sections/GroupCards/cardTypes';

/**
 * @param {string} type type of the chart that will be rendered.
 * where type = line|bar
 */
function getEvolutiveChartComponent(type = 'line') {
  return {
    line: LineChart,
    bar: BarChart,
  }[type];
}

export default function EvolutiveChart({
  type,
  legendsFilter,
  legendsFilterHandler,
  data = [],
  theme,
  updateEvolutiveChartColors,
  colorPickerColors,
  colors,
  chartFontSize,
  themeTitle,
  error,
  chartRef,
}) {
  const EvolutiveChartComponent = getEvolutiveChartComponent(type);

  return (
    <EvolutiveChartComponent
      key={`${theme.title}${error}`}
      data={data}
      updateChartColors={updateEvolutiveChartColors}
      colorPickerColors={colorPickerColors}
      colors={colors}
      legendsFilter={legendsFilter}
      legendsFilterHandler={legendsFilterHandler}
      theme={theme}
      themeTitle={themeTitle}
      error={error}
      chartFontSize={chartFontSize}
      chartRef={chartRef}
      cardType={EVOLUTIVE_CARD}
      chartType={type}
    />
  );
}
